import { useMemo } from 'react';
import { List, ListItem } from 'foundations-components/transitional/components/List';
import PortalIdParser from 'PortalIdParser';
import useObjectTypeId from 'framework-listing-lib/internal/hooks/useObjectTypeId';
import UnfiledAssetNavItem from 'framework-listing-lib/internal/Folders/components/UnfiledAssetsNavItem';
import { FOLDER_OBJECT_TYPE, FOLDER_PROPERTIES, UNFILED_ASSETS_ID } from '../constants/folders';
import useFetchFolders from '../hooks/useFetchFolders';
import useUnfiledAssetsName from '../hooks/useUnfiledAssetsName';
import FolderNavItem from './FolderNavItem';
import FolderNavItemDropTargetV2 from './FolderNavItemDropTargetV2';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
function FolderNavItemWrapper({
  children,
  folder,
  folderItemWidth,
  onDrop,
  variant
}) {
  if (variant === 'sidebar' && onDrop) {
    return /*#__PURE__*/_jsx(FolderNavItemDropTargetV2, {
      folder: folder,
      folderItemWidth: folderItemWidth,
      onDrop: onDrop,
      children: children
    });
  }
  return children;
}
export default function FolderTree({
  selectedAssetCount,
  currentFolderId,
  folderItemWidth = 0,
  isParentFolderOpen,
  onClick,
  onDrop,
  openFoldersMap,
  parentFolderId,
  variant,
  selectedAssetFolderId
}) {
  const objectType = useObjectTypeId();
  const intParentFolderId = parentFolderId || UNFILED_ASSETS_ID;
  const {
    folders
  } = useFetchFolders({
    objectType,
    parentFolderId: intParentFolderId,
    skip: Boolean(parentFolderId && !isParentFolderOpen)
  });
  const unfiledAssetName = useUnfiledAssetsName();
  const unfiledAssetNameFolder = useMemo(() => ({
    objectId: UNFILED_ASSETS_ID,
    objectTypeId: FOLDER_OBJECT_TYPE,
    portalId: PortalIdParser.get(),
    properties: {
      [FOLDER_PROPERTIES.name]: {
        value: unfiledAssetName
      }
    }
  }), [unfiledAssetName]);
  if (folders.length === 0 && parentFolderId) {
    return null;
  }
  return /*#__PURE__*/_jsxs(List, {
    paddingInlineStart: parentFolderId ? '500' : '0',
    paddingBlockEnd: parentFolderId ? '0' : '500',
    children: [parentFolderId === undefined && /*#__PURE__*/_jsx(ListItem, {
      children: /*#__PURE__*/_jsx(FolderNavItemWrapper, {
        folder: unfiledAssetNameFolder,
        folderItemWidth: folderItemWidth,
        onDrop: onDrop,
        variant: variant,
        children: /*#__PURE__*/_jsx(UnfiledAssetNavItem, {
          selectedAssetCount: selectedAssetCount,
          folder: unfiledAssetNameFolder,
          isSelected: currentFolderId === UNFILED_ASSETS_ID,
          onClick: onClick,
          openFoldersMap: openFoldersMap,
          selectedAssetFolderId: selectedAssetFolderId
        })
      })
    }), folders.map(childFolder => /*#__PURE__*/_jsxs(ListItem, {
      children: [/*#__PURE__*/_jsx(FolderNavItemWrapper, {
        folder: childFolder,
        folderItemWidth: folderItemWidth,
        onDrop: onDrop,
        variant: variant,
        children: /*#__PURE__*/_jsx(FolderNavItem, {
          selectedAssetCount: selectedAssetCount,
          folder: childFolder,
          isSelected: childFolder.objectId === currentFolderId,
          onClick: onClick,
          openFoldersMap: openFoldersMap,
          selectedAssetFolderId: selectedAssetFolderId
        })
      }), /*#__PURE__*/_jsx(FolderTree, {
        selectedAssetCount: selectedAssetCount,
        currentFolderId: currentFolderId,
        folderItemWidth: folderItemWidth,
        isParentFolderOpen: intParentFolderId in openFoldersMap && openFoldersMap[intParentFolderId].includes(childFolder.objectId),
        onClick: onClick,
        onDrop: onDrop,
        openFoldersMap: openFoldersMap,
        parentFolderId: childFolder.objectId,
        variant: variant,
        selectedAssetFolderId: selectedAssetFolderId
      })]
    }, childFolder.objectId))]
  });
}